import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { GetOrganization } from "../../../store/organization-store/organization-actions";
import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";

const OrganizationDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const organization = useSelector((state) => state.organization.organization);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (organization.id === undefined || organization.id === 0) {
      dispatch(GetOrganization(param.organizationId, userInfo.Email));
    }
  }, [param.organizationId, dispatch, organization.id, userInfo.Email]);
  let organizationData = [];
  if (
    organization !== undefined &&
    organization !== null &&
    organization.country !== null &&
    organization.country !== undefined &&
    organization.country.name !== null &&
    organization.country.name !== undefined
  ) {
    organizationData = [
      { label: "Identificador", value: organization.identifier },
      { label: "País", value: organization.country.name },
      { label: "Ciudad", value: organization.city },
      { label: "Código Postal", value: organization.zipCode },
      { label: "Dirección", value: organization.address },
      { label: "Email", value: organization.email },
      // { label: "RA", value: organization.ra },
    ];
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {(organization.id === undefined || organization.id <= 0) && (
          <>
            <Loading />
          </>
        )}
        {(organization.id !== undefined || organization.id > 0) && (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
              height: "auto",
            }}
          >
            <div
              className="user-info text-center"
              style={{
                borderBottom: "solid #fff",
                fontWeight: "bold",
                paddingBottom: "1.3%",
              }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {organization.name.toUpperCase()}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                Organizacion
              </span>
            </div>
            <div className="formgrid grid ">
              <div className="field col-12 md:col-12 mt-3">
                <DataTable
                  value={organizationData}
                  style={{ width: "100%", padding: "1%" }}
                >
                  <Column
                    field="label"
                    style={{ width: "50%", textAlign: "right" }}
                    bodyStyle={{ textAlign: "left", fontWeight: "bold" }}
                  />
                  <Column
                    field="value"
                    style={{ width: "50%", textAlign: "left" }}
                    bodyStyle={{ textAlign: "left" }}
                  />
                </DataTable>
              </div>
              <div className="field col-12 md:col-3 ">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "150px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/organization");
                  }}
                />
              </div>
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("organization.edit") && (
                  <div className="field col-12 md:col-3 ">
                    <Button
                      rounded
                      text
                      raised
                      style={{ backgroundColor: "#fff", width: "150px" }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/organization/edit/${organization.id}`);
                      }}
                    />
                  </div>
                )}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
export default OrganizationDetail;
